import React, { Component } from 'react';
import './Room.css';

import { Button } from 'react-bootstrap';

import { subscribeToRoom, updateState, reset } from './api';

class Room extends Component {
  constructor(props) {
    super(props);

    subscribeToRoom(this.props.roomId, (err, data) => {
        const {id, name, ...timestamps} = data;
        const toBeUpdated = {
            roomName: data.name,
            timestamps
        };

        if (!this.state.readyToBeDischarged && timestamps.patient_ready_to_be_discharged) {
            toBeUpdated.readyToBeDischarged = true;
        } else {
            toBeUpdated.readyToBeDischarged = false;
        }

        if (timestamps.patient_ready === null &&
            timestamps.infusion_started === null &&
            timestamps.syringe_changed === null &&
            timestamps.patient_ready_to_be_discharged === null) {
                toBeUpdated.timeElapsed = 0;
        }

        this.setState(
            toBeUpdated
        );
    });

    this.warnThreshold = 2280000; // 38 minutes

    this.tick = this.tick.bind(this);
    this.display = this.display.bind(this);
    this._patientReady = this._patientReady.bind(this);
    this._beginInfusion = this._beginInfusion.bind(this);
    this._changeSyringe = this._changeSyringe.bind(this);
    this._discharge = this._discharge.bind(this);
  }

  state = {
    roomName: 'Exam Room',
    roomId: this.props.roomId,
    timestamps: {},
    timeElapsed: 0,
  };

  componentDidMount() {
    this.interval = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
      clearInterval(this.interval);
  }

  // https://coderwall.com/p/wkdefg/converting-milliseconds-to-hh-mm-ss-mmm
  prettyTime(ms) {
    var milliseconds = parseInt((ms%1000)/100)
        , seconds = parseInt((ms/1000)%60)
        , minutes = parseInt((ms/(1000*60))%60)
        , hours = parseInt((ms/(1000*60*60))%24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
  }

  tick() {
    if (this.state && this.state.timestamps.infusion_started) {
        if (!this.state.timestamps.patient_ready_to_be_discharged) {
            let now = new Date();
            let is = new Date(this.state.timestamps.infusion_started);
            let timeElapsed = now - is;

            const toBeUpdated = {
                timeElapsed
            };

            if (timeElapsed > this.warnThreshold && !this.state.timestamps.syringe_changed) {
                toBeUpdated.shouldWarn = true;
            } else if (this.state.shouldWarn) {
                toBeUpdated.shouldWarn = false;
            }
         
            this.setState(toBeUpdated);
        } else if (this.state.timeElapsed === 0) {
            // We haven't initialized this yet, so let's set it once
            let start = new Date(this.state.timestamps.infusion_started);
            let end = new Date(this.state.timestamps.patient_ready_to_be_discharged);
            let timeElapsed = end - start;
            this.setState({
                timeElapsed
            });
        }
    }
  }

  _patientReady() {
    updateState(this.props.roomId, 'patient_ready');
  }

  _beginInfusion() {
    updateState(this.props.roomId, 'infusion_started');
  }

  _changeSyringe() {
    updateState(this.props.roomId, 'syringe_changed');
  }

  _discharge() {
    if (!this.state.timestamps.patient_ready_to_be_discharged) {
        // Patient is ready to be discharged
        updateState(this.props.roomId, 'patient_ready_to_be_discharged');
    } else {
        // Reset
        reset(this.props.roomId);
    }
  }

  display() {
      const timestamps = this.state.timestamps;
      if (timestamps.patient_ready === null &&
          timestamps.infusion_started === null &&
          timestamps.syringe_changed === null &&
          timestamps.patient_ready_to_be_discharged === null) {
              return (<Button onClick={this._patientReady} bsStyle="info">Initialize</Button>);
        } else {
            let finalButtonTxt = (timestamps.patient_ready_to_be_discharged) ? "Reset" : "Ready to be Discharged";
            let mainDisplay = (timestamps.infusion_started) ? this.prettyTime(this.state.timeElapsed) : "Patient Ready";

            return (
                <div className="Room-wrap">
                    <p className="timer">{mainDisplay}</p>
                    <div className="btns-wrap">
                        <Button onClick={this._beginInfusion} bsStyle="success" disabled={!!timestamps.infusion_started}>Begin Infusion</Button>
                        <Button onClick={this._changeSyringe} bsStyle="warning" disabled={!!timestamps.syringe_changed}>Change Syringe</Button>
                        <Button onClick={this._discharge} bsStyle="danger">{finalButtonTxt}</Button>
                    </div>
                </div>    
            );
        }
  }

  render() {
    let mainClassName = "Room";
    if (this.state.shouldWarn) {
        mainClassName += " warn";
    } else if (this.state.readyToBeDischarged) {
        mainClassName += " ready-to-be-discharged";
    }

    return (
      <div className={mainClassName}>
        <header className="Room-header">
          <h3 className="Room-title">{this.state.roomName}</h3>
        </header>
        <div className="Room-main">
          {this.display()}
        </div>
      </div>
    );
  }
}

export default Room;



// WEBPACK FOOTER //
// ./src/Room.js